import {DatePipe} from '@angular/common';
import {Pipe, PipeTransform} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {registerLocaleData} from '@angular/common';

import localeEn from '@angular/common/locales/en';
import localePt from '@angular/common/locales/pt';
import localeSp from '@angular/common/locales/es';
registerLocaleData(localeEn);
registerLocaleData(localePt);
registerLocaleData(localeSp);

@Pipe({
    name: 'date'
})

export class DatePipeProxy implements PipeTransform {

    constructor(private _translateService: TranslateService) {}

    public transform(value: any, pattern: string = 'mediumDate'): any {
         const ngPipe = new DatePipe(this._translateService.currentLang);
         return ngPipe.transform(value, pattern);
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/translate/datePipeProxy.component.ts